import React from 'react';
import { string } from 'prop-types';
import {
  IconAirplane,
  IconCheck,
  IconEntertainment,
  IconHotel,
  IconLounge,
  IconMerchandise,
  IconDollar,
  IconRewards,
} from '@americanexpress/dls-icons';
import styles from '@americanexpress/web-react-extensions/styles/viewAll.scss';

const IconComponent = ({ icon, iconSize, iconColor, isFilled, className }) => {
  const iconMapping = {
    IconAirplane,
    IconCheck,
    IconEntertainment,
    IconHotel,
    IconLounge,
    IconMerchandise,
    IconDollar,
    IconRewards,
  };
  const IconImage = iconMapping[icon];
  const shouldRenderIcon = typeof IconImage === 'function';
  let classes = '';
  if (iconSize !== 'sm') {
    classes = className || 'col-xs-2 col-md-1 pad-1-l';
  }
  return shouldRenderIcon && (
    <section data-testid={`icon-section-${icon}`} className={classes}>
      <IconImage
        size={iconSize}
        color={iconColor}
        titleId={`icon-${icon}`}
        data-testid={`icon-${icon}`}
        isFilled={isFilled}
        className={`${iconSize === 'sm' ? '' : styles.iconCircularBackground}`}
      />
    </section>
  );
};

IconComponent.propTypes = {
  icon: string.isRequired,
  iconColor: string,
  className: string,
  iconSize: string,
};

export default IconComponent;
